import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2Icon, BookOpenIcon, GiftIcon, CalculatorIcon, AlertTriangleIcon, DownloadIcon, CreditCardIcon, ChevronDownIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function BonusSection() {
  const [expandedBono1, setExpandedBono1] = useState(false);
  const [expandedBono2, setExpandedBono2] = useState(false);
  const [expandedBono3, setExpandedBono3] = useState(false);
  return <section className="w-full bg-white py-10 md:py-24 px-6" data-id="element-15">
      <div className="max-w-5xl mx-auto" data-id="element-16">
        {/* Intro */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center max-w-3xl mx-auto mb-16" data-id="element-17">
          <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-bold text-[#1C1C1C] mb-6" data-id="element-18">
            Pero eso no es todo lo que recibís hoy.
          </h2>
          <p className="text-lg text-[#1C1C1C]/80 leading-relaxed" data-id="element-19">
            Cuando decidís resolver esto de una vez, no tiene sentido darte solo
            el protocolo y dejarte solo con la implementación. Por eso, junto al
            eBook principal, vas a recibir{' '}
            <strong data-id="element-20">3 herramientas de implementación inmediata</strong> — sin
            costo adicional.
          </p>
        </motion.div>

        <div className="w-full h-px bg-[#1C1C1C]/10 mb-16" data-id="element-21"></div>

        {/* Bono 1 */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="grid md:grid-cols-2 gap-10 items-start mb-20 bg-[#FAFAF7] p-8 md:p-10 rounded-2xl border border-[#1C1C1C]/5" data-id="element-22">
          <div className="order-2 md:order-1" data-id="element-23">
            <div className="inline-block bg-[#2D8C5A]/10 text-[#2D8C5A] font-semibold px-4 py-1.5 rounded-full text-sm mb-4" data-id="element-24">
              BONO #1
            </div>
            <h3 className="font-['Playfair_Display'] text-2xl md:text-3xl font-bold text-[#1C1C1C] mb-2" data-id="element-25">
              Auditoría Express "Puntos Calientes" (10 Min) + Mapa de Bandejas
              N+1
            </h3>
            <p className="text-[#8B4513] font-semibold mb-6" data-id="element-26">
              Valor real:{' '}
              <span className="line-through opacity-70" data-id="element-27">$14.000 ARS</span> —
              Hoy: GRATIS
            </p>
            <p className="text-[#1C1C1C]/80 mb-4 leading-relaxed" data-id="element-28">
              Antes de mover una sola bandeja o comprar cualquier producto,
              necesitás saber exactamente dónde y por qué tu gato vuelve al
              mismo lugar una y otra vez.
            </p>

            <AnimatePresence data-id="element-29">
              {expandedBono1 && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.35,
              ease: 'easeInOut'
            }} className="overflow-hidden" data-id="element-30">
                  <div className="pt-2" data-id="element-31">
                    <p className="text-[#1C1C1C]/80 mb-6 leading-relaxed" data-id="element-32">
                      Este bono te da una auditoría guiada de 10 minutos para
                      detectar los disparadores reales del marcaje en tu hogar.
                      No es teoría. Es una herramienta de diagnóstico con
                      checklist de barrido, scorecard de riesgo (0 a 20 puntos)
                      y mapas de ubicación N+1 listos para 1, 2 o 3 gatos.
                    </p>
                    <p className="text-[#1C1C1C]/80 mb-6 leading-relaxed italic" data-id="element-33">
                      La mayoría de los dueños de gatos pierden semanas
                      "probando cosas". Este bono te dice exactamente qué
                      cambiar primero, en 10 minutos, desde el primer día.
                    </p>

                    <div className="space-y-3 mb-6" data-id="element-34">
                      {['Checklist "Barrido del Hogar en 10 Min" (imprimible)', 'Scorecard de riesgo para detectar si la bandeja está mal ubicada aunque "parezca bien"', 'Mapas N+1 listos para 1, 2 y 3 gatos', 'Plantilla "Mis 2 ubicaciones candidatas"', 'Tracker de 7 días para detectar el patrón exacto del marcaje'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-35">
                          <CheckCircle2Icon className="w-5 h-5 text-[#2D8C5A] flex-shrink-0 mt-0.5" data-id="element-36" />
                          <span className="text-[#1C1C1C]/90" data-id="element-37">{item}</span>
                        </div>)}
                    </div>
                    <div className="bg-white p-4 rounded-lg border border-[#2D8C5A]/20 mb-4" data-id="element-38">
                      <p className="text-[#1C1C1C] font-medium" data-id="element-39">
                        <span className="text-[#2D8C5A] font-bold" data-id="element-40">
                          Resultado esperado:
                        </span>{' '}
                        En 10 minutos sabés qué cambiar. En 48 horas ya lo
                        cambiaste. En 7 días tenés el patrón identificado.
                      </p>
                    </div>
                  </div>
                </motion.div>}
            </AnimatePresence>

            <button onClick={() => setExpandedBono1(!expandedBono1)} className="flex items-center gap-1.5 text-[#2D8C5A] font-semibold hover:text-[#1f6b42] transition-colors cursor-pointer" data-id="element-41">
              <span data-id="element-42">{expandedBono1 ? 'Ver menos' : 'Leer más detalles'}</span>
              <motion.div animate={{
              rotate: expandedBono1 ? 180 : 0
            }} transition={{
              duration: 0.25
            }} data-id="element-43">
                <ChevronDownIcon className="w-4 h-4" data-id="element-44" />
              </motion.div>
            </button>
          </div>
          <div className="order-1 md:order-2 flex justify-center" data-id="element-45">
            <img src="https://cdn.magicpatterns.com/uploads/fCqSNXB1Kex3m9afbe5REW/bono_01.png" alt="Bono 1 - Auditoría Express" className="w-full max-w-md rounded-xl shadow-xl" data-id="element-46" />
          </div>
        </motion.div>

        {/* Bono 2 */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="grid md:grid-cols-2 gap-10 items-start mb-20 bg-[#FAFAF7] p-8 md:p-10 rounded-2xl border border-[#1C1C1C]/5" data-id="element-47">
          <div className="flex justify-center" data-id="element-48">
            <img src="https://cdn.magicpatterns.com/uploads/xkgUMUk7B7oPpzmQjY9nqM/bono_02.png" alt="Bono 2 - Kit de Comunicación" className="w-full max-w-md rounded-xl shadow-xl" data-id="element-49" />
          </div>
          <div data-id="element-50">
            <div className="inline-block bg-[#2D8C5A]/10 text-[#2D8C5A] font-semibold px-4 py-1.5 rounded-full text-sm mb-4" data-id="element-51">
              BONO #2
            </div>
            <h3 className="font-['Playfair_Display'] text-2xl md:text-3xl font-bold text-[#1C1C1C] mb-2" data-id="element-52">
              Kit de Comunicación "Sin Culpa" (Scripts + Carteles de Casa + Plan
              de 3 Días)
            </h3>
            <p className="text-[#8B4513] font-semibold mb-6" data-id="element-53">
              Valor real:{' '}
              <span className="line-through opacity-70" data-id="element-54">$12.700 ARS</span> —
              Hoy: GRATIS
            </p>
            <p className="text-[#1C1C1C]/80 mb-4 leading-relaxed" data-id="element-55">
              El protocolo falla cuando la casa no está alineada. Cuando alguien
              grita, cambia la arena por impulso o deja una puerta abierta "sin
              querer", todo el progreso retrocede. No porque el método no sirva,
              sino porque el estrés humano se transfiere directamente al gato.
            </p>

            <AnimatePresence data-id="element-56">
              {expandedBono2 && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.35,
              ease: 'easeInOut'
            }} className="overflow-hidden" data-id="element-57">
                  <div className="pt-2" data-id="element-58">
                    <p className="text-[#1C1C1C]/80 mb-6 leading-relaxed" data-id="element-59">
                      Este kit te da las palabras exactas para que tu pareja,
                      tus hijos, tus visitas y tu roommate entiendan las reglas
                      sin discusiones, sin dramas y sin que tengas que explicar
                      etología felina a las 11 de la noche.
                    </p>

                    <div className="space-y-3 mb-6" data-id="element-60">
                      {['12 scripts listos (copiar/pegar por WhatsApp o decir en casa) para pareja, hijos, visitas y roommates', 'Protocolo Silencioso 90s: qué hacer en 90 segundos cuando hay un accidente (sin gritar, sin empeorar)', '6 carteles imprimibles para puertas, lavadero y zona de bandeja', 'Plan simple de 3 días (rutina mañana/tarde/noche) para sostener la implementación', 'Auto-guión anti-culpa: la frase exacta para resetear tu cabeza cuando creés que fallaste'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-61">
                          <CheckCircle2Icon className="w-5 h-5 text-[#2D8C5A] flex-shrink-0 mt-0.5" data-id="element-62" />
                          <span className="text-[#1C1C1C]/90" data-id="element-63">{item}</span>
                        </div>)}
                    </div>
                    <div className="bg-white p-4 rounded-lg border border-[#2D8C5A]/20 mb-4" data-id="element-64">
                      <p className="text-[#1C1C1C] font-medium" data-id="element-65">
                        <span className="text-[#2D8C5A] font-bold" data-id="element-66">
                          Resultado esperado:
                        </span>{' '}
                        Casa alineada desde el Día 1. Sin sabotajes. Sin
                        retrocesos.
                      </p>
                    </div>
                  </div>
                </motion.div>}
            </AnimatePresence>

            <button onClick={() => setExpandedBono2(!expandedBono2)} className="flex items-center gap-1.5 text-[#2D8C5A] font-semibold hover:text-[#1f6b42] transition-colors cursor-pointer" data-id="element-67">
              <span data-id="element-68">{expandedBono2 ? 'Ver menos' : 'Leer más detalles'}</span>
              <motion.div animate={{
              rotate: expandedBono2 ? 180 : 0
            }} transition={{
              duration: 0.25
            }} data-id="element-69">
                <ChevronDownIcon className="w-4 h-4" data-id="element-70" />
              </motion.div>
            </button>
          </div>
        </motion.div>

        {/* Bono 3 */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="grid md:grid-cols-2 gap-10 items-start mb-20 bg-[#FAFAF7] p-8 md:p-10 rounded-2xl border border-[#1C1C1C]/5" data-id="element-71">
          <div className="order-2 md:order-1" data-id="element-72">
            <div className="inline-block bg-[#2D8C5A]/10 text-[#2D8C5A] font-semibold px-4 py-1.5 rounded-full text-sm mb-4" data-id="element-73">
              BONO #3
            </div>
            <h3 className="font-['Playfair_Display'] text-2xl md:text-3xl font-bold text-[#1C1C1C] mb-2" data-id="element-74">
              Checklist "Bandeja Perfecta" (2 Min al Día)
            </h3>
            <p className="text-[#8B4513] font-semibold mb-6" data-id="element-75">
              Valor real:{' '}
              <span className="line-through opacity-70" data-id="element-76">$9.500 ARS</span> — Hoy:
              GRATIS
            </p>
            <p className="text-[#1C1C1C]/80 mb-4 leading-relaxed" data-id="element-77">
              El protocolo de 72 horas resuelve el problema. Este bono se
              asegura de que no vuelva.
            </p>

            <AnimatePresence data-id="element-78">
              {expandedBono3 && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.35,
              ease: 'easeInOut'
            }} className="overflow-hidden" data-id="element-79">
                  <div className="pt-2" data-id="element-80">
                    <p className="text-[#1C1C1C]/80 mb-4 leading-relaxed" data-id="element-81">
                      Porque la mayoría de las recaídas no ocurren porque el
                      protocolo falló. Ocurren porque después de los primeros
                      días de alivio, volvemos a la rutina anterior sin darnos
                      cuenta. Y el gato lo detecta antes que nosotros.
                    </p>
                    <p className="text-[#1C1C1C]/80 mb-6 leading-relaxed" data-id="element-82">
                      Este bono es la herramienta más simple del pack: 2 minutos
                      al día. Nada más. Una checklist AM/PM para mantener la
                      bandeja en el estándar exacto que hace que tu gato la
                      elija por instinto, todos los días, sin excepciones. No
                      requiere leer. No requiere tiempo. Solo seguir la lista.
                    </p>

                    <div className="space-y-3 mb-6" data-id="element-83">
                      {['Checklist AM/PM imprimible (1 página A4 para pegar cerca de la bandeja)', 'Rutina de reset semanal anti-recaídas (5–10 min por semana)', 'Tracker de 14 días (lista por día con AM/PM + campo de evento)', 'Mini guía "3 ajustes express si tu gato evita la caja"', 'Versión móvil optimizada para celular'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-84">
                          <CheckCircle2Icon className="w-5 h-5 text-[#2D8C5A] flex-shrink-0 mt-0.5" data-id="element-85" />
                          <span className="text-[#1C1C1C]/90" data-id="element-86">{item}</span>
                        </div>)}
                    </div>
                    <div className="bg-white p-4 rounded-lg border border-[#2D8C5A]/20 mb-4" data-id="element-87">
                      <p className="text-[#1C1C1C] font-medium" data-id="element-88">
                        <span className="text-[#2D8C5A] font-bold" data-id="element-89">
                          Resultado esperado:
                        </span>{' '}
                        En 14 días de uso consistente, el hábito de caja se
                        consolida y las recaídas se vuelven excepciones
                        manejables, no catástrofes.
                      </p>
                    </div>
                  </div>
                </motion.div>}
            </AnimatePresence>

            <button onClick={() => setExpandedBono3(!expandedBono3)} className="flex items-center gap-1.5 text-[#2D8C5A] font-semibold hover:text-[#1f6b42] transition-colors cursor-pointer" data-id="element-90">
              <span data-id="element-91">{expandedBono3 ? 'Ver menos' : 'Leer más detalles'}</span>
              <motion.div animate={{
              rotate: expandedBono3 ? 180 : 0
            }} transition={{
              duration: 0.25
            }} data-id="element-92">
                <ChevronDownIcon className="w-4 h-4" data-id="element-93" />
              </motion.div>
            </button>
          </div>
          <div className="order-1 md:order-2 flex justify-center" data-id="element-94">
            <img src="https://cdn.magicpatterns.com/uploads/hbdDUCV5APquy5RTi4q38J/bono_03.png" alt="Bono 3 - Checklist Bandeja Perfecta" className="w-full max-w-md rounded-xl shadow-xl" data-id="element-95" />
          </div>
        </motion.div>

        {/* CTA after Bono 3 */}

        {/* Closing Headline & Urgency */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-3xl mx-auto text-center" data-id="element-96">
          <h3 className="font-['Playfair_Display'] text-2xl md:text-3xl font-bold text-[#1C1C1C] mb-6" data-id="element-97">
            Pagás $8.999. Recibís $45.199 en herramientas reales de
            implementación.
          </h3>
          <p className="text-lg text-[#1C1C1C]/80 leading-relaxed mb-8" data-id="element-98">
            No es un "paquete inflado". Es que cada pieza resuelve una etapa
            distinta del problema:
            <br data-id="element-99" />
            <br data-id="element-100" />
            <strong data-id="element-101">📘 El Protocolo</strong> te da el sistema.
            <br data-id="element-102" />
            <strong data-id="element-103">🎁 Bono #1</strong> te dice exactamente qué cambiar primero.
            <br data-id="element-104" />
            <strong data-id="element-105">🎁 Bono #2</strong> alinea a toda la casa para no sabotear
            el proceso.
            <br data-id="element-106" />
            <strong data-id="element-107">🎁 Bono #3</strong> sostiene los resultados para que no
            vuelva a pasar.
            <br data-id="element-108" />
            <br data-id="element-109" />
            Sin las 4 piezas juntas, estás resolviendo el problema a medias.
          </p>

          <div className="bg-[#8B4513]/10 border border-[#8B4513]/20 rounded-xl p-6 mb-12 flex items-start gap-4 text-left" data-id="element-110">
            <AlertTriangleIcon className="w-6 h-6 text-[#8B4513] flex-shrink-0 mt-0.5" data-id="element-111" />
            <p className="text-[#8B4513] leading-relaxed" data-id="element-112">
              <strong data-id="element-113">Importante:</strong> Los 3 bonos están disponibles en esta
              página mientras dure esta oferta. No garantizamos que sigan
              incluidos en la próxima actualización de precios del pack.
            </p>
          </div>

          <div className="bg-white p-8 rounded-2xl border border-[#1C1C1C]/10 shadow-sm" data-id="element-114">
            <p className="text-lg text-[#1C1C1C] leading-relaxed mb-6" data-id="element-115">
              Hoy podés seguir probando productos, lavando sábanas a la
              madrugada y poniendo fundas en el sofá. O podés resolver esto este
              fin de semana con un sistema completo que ataca el problema desde
              la causa real, te da herramientas para implementarlo sin fricción
              y te asegura que no vuelva a pasar.
            </p>
            <p className="text-xl font-['Playfair_Display'] font-semibold text-[#2D8C5A] leading-relaxed" data-id="element-116">
              Tu casa puede volver a oler a tu casa. Tu gato puede dejar de
              gritarte en el único idioma que conoce. Y vos podés volver a
              sentarte en el sofá sin mirar el rincón primero.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}